import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import DropDown from 'src/components/common/field/DropDown';
import { ItemType } from 'src/components/common/field/TypeCustom';
import { FieldTableType } from './TypeCustom';

type RecordItemProps = {
  item: any;
  fields: FieldTableType[];
  baseData?: any,
  statuses?: ItemType[];
  index?: number;
  onClickRow?: (data: any | undefined) => void;
  onClickBtnEdit?: (data: any | undefined) => void;
  onClickBtnDelete?: (data: any | undefined) => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {
  const getStatusName = (id: number | string | null) => {
    const status = props.statuses && props.statuses.find(status => status.id === String(id));
    return status ? status.name : '-';
  };

  const getStatusColor = (id: number | string | null) => {
    const status = props.statuses && props.statuses.find(status => status.id === String(id));
    return status ? status.accessories : '';
  };

  const handleClickRow = (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    const target = event.target as HTMLElement;
    const isDropdownOrButton =
      target.closest('td')?.querySelector('.MuiOutlinedInput-root') ||
      target.closest('.MuiPopover-root') ||
      target.closest('td')?.querySelector('.MuiButtonBase-root');

    if (!isDropdownOrButton) {
      props.onClickRow?.(props.item);
    }
  };

  const handleClickEdit = () => {
    props.onClickBtnEdit?.(props.item);
  };

  const handleClickDelete = () => {
    props.onClickBtnDelete?.(props.item);
  };

  const getDataItem = (field: string) => {
    return props.item[field] || props.item[field] === 0 ? props.item[field] : '-';
  };

  return (
    <TableRow
      hover
      onClick={handleClickRow}
      key={props.item.id}
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        '& .MuiTableCell-root.MuiTableCell-body': {
          py: '4px',
          borderBottom: '1px solid #F3F3F3',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '14.4px'
        },
        height: '48px',
      }}
    >
      {props.fields.map((field, index: number) => (
        field.child ? (
          <TableCell key={index} component='th' scope='row'>
            {field.child}
          </TableCell>
        ) : (
          field.field !== 'action' ? (

            field.isStatus ? (
              field.dropdownStatus ? (
                <TableCell key={index} component='td' scope='row'>
                  <Box sx={{ width: '104px' }}>
                    <DropDown
                      selected={getDataItem(field.field)}
                      idSelect='Dropdown-table'
                      items={props.statuses}
                      sxInput={{
                        bgcolor: getStatusColor(getDataItem(field.field)),
                        width: '104px',
                        height: '32px',
                        '.MuiSvgIcon-root': { fontSize: '24px', color: 'white' },
                        '& .MuiSelect-select': {
                          '.MuiTypography-body1': {
                            fontSize: '14px',
                            fontWeight: 700,
                            color: 'primary.light'
                          }
                        },
                      }}
                      sxLabel={{
                        '&.Mui-focused': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
                        '&.MuiInputLabel-root': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
                      }}
                      onChange={(id: number | string) => { }}
                    />
                  </Box>
                </TableCell>
              ) : (
                field.boxStatus ? (
                  <TableCell key={index} component='td' scope='row' sx={{ cursor: 'pointer' }}>
                    <Box sx={{
                      width: '104px',
                      height: '32px',
                      borderRadius: '4px',
                      display: 'flex',
                      justifyContent: 'center',
                      px: '10px',
                      bgcolor: getStatusColor(getDataItem(field.field)),
                    }}>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 700,
                          color: 'primary.light',
                          alignContent: 'center'
                        }}
                      >
                        {getStatusName(getDataItem(field.field))}
                      </Typography>
                    </Box>
                  </TableCell>
                ) : (
                  <TableCell key={index} component='td' scope='row' sx={{ cursor: 'pointer' }}>
                    {getStatusName(getDataItem(field.field))}
                  </TableCell>
                )
              )
            ) : (
              field.dropdown ? (
                <TableCell key={index} component='td' scope='row' sx={{ cursor: 'pointer' }}>
                  <Box sx={{ width: '104px' }}>
                    <DropDown
                      selected={getDataItem(field.field)}
                      idSelect='Dropdown-table'
                      items={props.baseData[field.dropdown] ? props.baseData[field.dropdown] : {}}
                      sxInput={{
                        width: '130px',
                        height: '32px',
                        '.MuiSvgIcon-root': { fontSize: '24px' },
                        '& .MuiSelect-select': {
                          '.MuiTypography-body1': {
                            fontSize: '14px',
                            fontWeight: 700,
                          }
                        },
                      }}
                      sxLabel={{
                        '&.Mui-focused': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
                        '&.MuiInputLabel-root': { color: '#AAB2BD', transform: 'translate(14px, 8px) scale(1)' },
                      }}
                      onChange={(id: number | string) => { }}
                    />
                  </Box>
                </TableCell>
              ) : (
                <TableCell key={index} component='td' scope='row' sx={{ cursor: 'pointer' }}>
                  <Typography
                    sx={{
                      whiteSpace: 'pre-wrap',
                      fontSize: '14px',
                      fontWeight: 400,
                      lineHeight: '14.4px'
                    }}>
                    {field.field === 'index' ? props.index : ((field.isPrice ? '¥' : '') + getDataItem(field.field))}
                  </Typography>
                </TableCell>
              )
            )
          ) : (
            <TableCell key={index} component='td' scope='row'>
              <Box display={'flex'} justifyContent={'right'}>
                <BtnOutlineGradient
                  text='変更'
                  handleButtonClick={handleClickEdit}
                  sx={{
                    width: '60px',
                    mr: '15px'
                  }}
                  sxButton={{
                    minWidth: '55px'
                  }}
                />
                <BtnOutlineGradient
                  text='削除'
                  handleButtonClick={handleClickDelete}
                  sxText={{
                    background: '#DA4453'
                  }}
                  sx={{
                    width: '60px',
                    background: '#DA4453'
                  }}
                  sxButton={{
                    minWidth: '56px'
                  }}
                />
              </Box>
            </TableCell>
          )
        )
      ))}
    </TableRow >
  );
};

export default RecordItem;
